/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import { Component, OnInit } from '@angular/core';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';
import {UserService} from '../../_services/user.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  currentYear: number;
  isLoggedIn: Observable<boolean>;
  env = environment;

  constructor(
    public translate: TranslateService,
    private userService: UserService
  ) {
    this.currentYear = (new Date()).getFullYear();
  }

  ngOnInit(): void {
    this.isLoggedIn = this.userService.isAuthenticated;
  }

  get applicationVersion() {
    return environment.cecewm_version;
  }

}
